'use client'

import { Flex } from "@radix-ui/themes";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../ui/form";
import { Input } from "../../ui/input";
import { FieldPath, FieldValues } from 'react-hook-form';
import { FieldProps } from "../FieldProps";
import { InfoTooltip } from "../FormInfo";
import { Skeleton } from "../../ui/skeleton";

export function TitleField<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  loading = false,
}: FieldProps<TFieldValues, TName>) {
  if (loading) {
    return <Flex className="w-full" direction="column" gap="2">
      <FormLabel className="text-sm">Title</FormLabel>
      <Skeleton className="w-60 h-6" />
    </Flex>
  }

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm">
            <Flex align="center">
              <span>Title</span>
              <InfoTooltip className="px-2 w-fit">
                This is title of the auction visible to buyers.
              </InfoTooltip>
            </Flex>
          </FormLabel>
          <FormControl>
            <Input placeholder="Auction Title" {...field} className="w-60 text-sm" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

export default TitleField
